import React from "react";
import { JOB_STATES_DISPLAY } from "../../../../utils/constants";
import VrDraftingJobServicesTable from "./VrDraftingJobServicesTable";

const JobServicesByVrDraftsmanTable = ({
  jobServices,
  setJobServices,
  reloadData
}) => {
  const jobServicesByVrDraftsman = _.isEmpty(jobServices) ? [] : Object.keys(jobServices).sort()
  const unassignedIndex = jobServicesByVrDraftsman.indexOf("Unassigned")
  if (unassignedIndex !== -1) {
    jobServicesByVrDraftsman.unshift(jobServicesByVrDraftsman.splice(unassignedIndex, 1)[0]);
  }

  return (
    <>
      {jobServicesByVrDraftsman.map(vr_draftsman => {
        const jobServicesForVrDraftsman = jobServices[vr_draftsman]
        return (
          (!!jobServicesForVrDraftsman?.length && (
            <div key={`data-${vr_draftsman}`}>
              <h3 className="text-dark pt-5">{vr_draftsman}</h3>
              <VrDraftingJobServicesTable
                jobServices={jobServicesForVrDraftsman}
                setJobServices={setJobServices}
                reloadData={reloadData} />
            </div>
          ))
        )
      })}
    </>
  )
}

export default JobServicesByVrDraftsmanTable